import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .margin-view-overlays .current-line,.monaco-editor .view-overlays .current-line{box-sizing:border-box;display:block;height:100%;left:0;position:absolute;top:0}.monaco-editor\n\t.margin-view-overlays\n\t.current-line.current-line-margin.current-line-margin-both{border-right:0}";
n(css,{});
export { css, css as default };
